import * as types from '../actions/action-types';

const initialState = {
  fetching: false,
  fetched: false,
  error: null,
  invites: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_INVITES_PENDING:
      return {
        ...state,
        fetching: true,
        fetched: false,
        error: null
      };

    case types.FETCH_INVITES_FULFILLED:
      return {
        ...state,
        invites: action.payload.invites,
        fetching: false,
        fetched: true,
        error: null
      };

    case types.FETCH_INVITES_REJECTED:
      return {
        ...state,
        fetching: false,
        error: action.payload
      };

    case types.CREATE_INVITE_PENDING:
      return {
        ...state,
        creating: true,
        errorCreating: false
      };

    case types.CREATE_INVITE_FULFILLED:
      const invites = [].concat([ action.payload ], state.invites);
      return {
        ...state,
        creating: false,
        errorCreating: null,
        invites
      };

    case types.CREATE_INVITE_REJECTED:
      return {
        ...state,
        creating: false,
        errorCreating: action.payload
      };

    case types.CANCEL_INVITE_FULFILLED:
      // Replace the invite in the current state that was cancelled with the one
      // receieved from the cancel endpoint.
      let newInvites = state.invites.slice().map((inv) => {
        if (inv.id === action.payload.id) {
          return action.payload;
        }

        return inv;
      });

      return {
        ...state,
        invites: newInvites
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/invites-reducer.js